import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { codeUrl, relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import DatasetMenuItems from '../containers/DatasetMenuItems';

const DataLauncherDropdownMenu = ({
  allowCreate,
  allowRead,
  code,
}) => (
  <Dropdown
    className="aridhia-data-launcher-menu"
    icon={null}
    trigger={(<RibbonMenu name="datasets" message="fair.launcher.datasets" icon="database" />)}
  >
    <Dropdown.Menu>
      {allowCreate && (
        <Dropdown.Item
          as="a"
          href={codeUrl(urls.DATASET, code, '#')}
          selected={false}
        >
          <Icon name="plus" className="primary" />
          <FormattedMessage id="dataset.header.menu.new" />
        </Dropdown.Item>
      )}
      {allowRead && (
        <>
          {allowCreate && (
            <Dropdown.Divider />
          )}
          <Dropdown.Item
            as="a"
            href={`#${relativeUrl(urls.DATASETS)}`}
            selected={false}
          >
            <Icon name="list alternate" className="primary" />
            <FormattedMessage id="dataset.header.menu.filter.all" />
          </Dropdown.Item>
          <Dropdown.Item
            as="a"
            href={`#${relativeUrl(urls.COLLECTIONS)}`}
            selected={false}
          >
            <Icon name="object group outline" className="primary" />
            <FormattedMessage id="collection.header.menu.filter.all" />
          </Dropdown.Item>
          <DatasetMenuItems category="ribbon" />
        </>
      )}
    </Dropdown.Menu>
  </Dropdown>
);

export default DataLauncherDropdownMenu;
